import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <section className="footer-section text-center py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <small style={{ color: "#45a29e" }}>
              Designed {" & "} Built by{" "}
              <a
                style={{ textDecoration: "none", color: "#C5C6C7" }}
                rel="noreferrer"
                target="_blank"
                href="https://www.linkedin.com/in/showkatjubayer"
              >
                {" "}
                Showkat Jubayer
              </a>
            </small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
